var exports = {
  "t": "DataDeletionTab.module__deleteSection___N3RPUV",
  "i": "DataDeletionTab.module__warningText___N3RPUV",
};

module.exports = exports;
